// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:

// Redux:
import { createTopic } from 'actions/forum'

const host = window.location.host

class CreateTopic extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			show: false,
			title: '',
			content: '',
			privacy: '',
			userAddInput: '',
			userEmails: [],
			hasError: false
		}
	}

	handleShow = ( e ) => {
		this.setState({
			show: ! this.state.show
		})
	}

	handleTitleChange = ( e ) => {
		this.setState({
			title: e.target.value
		})
	}

	handleContentChange = ( e ) => {
		this.setState({
			content: e.target.value
		})
	}

	handlePrivacyChange = ( e ) => {
		this.setState({
			privacy: e.target.value
		})
	}

	handleUserAddChange = ( e ) => {
		this.setState({
			userAddInput: e.target.value
		})
	}

	handleUserAddSubmit = ( e ) => {
		e.preventDefault()

		const { userAddInput, userEmails } = this.state

		// Validate email:
		let hasError = ! userAddInput.match( /\S+@\S+\.\S+/ )

		// Prevent repeats:
		if ( userEmails.indexOf( userAddInput ) > -1 ) {
			hasError = true
		}

		if ( hasError ) {
			this.setState({
				hasError: true
			})
		} else {
			this.setState({
				userEmails: userEmails.concat( userAddInput ),
				hasError: false,
				userAddInput: ''
			})
		}
	}

	handleUserRemove = ( e ) => {
		const { userEmails } = this.state
		const thisEmail = e.getAttribute( 'data-email' )

		this.setState({
			userEmails: userEmails.filter( i => i != thisEmail ),
			hasError: false
		})
	}

	handleCreateTopic = ( e ) => {
		const { createTopic } = this.props
		const { title, content, privacy, userEmails } = this.state

		createTopic( title, content, privacy, userEmails )
	}

	render() {
		const { show, title, content, privacy, userAddInput, userEmails, hasError } = this.state
		const className = show ? 'forum-new-topic is-open' : 'forum-new-topic'
		const showButtonText = show ? 'Cancel' : 'Create topic'
		const showButtonClass = show ? 'button -cancel' : 'button'
		const buttonDisabled = title && content ? false : true
		const userAddClass = hasError ? '-user-add has-error' : '-user-add'
		let usersMarkup

		if ( userEmails.length ) {
			usersMarkup = userEmails.map( e => {
				return (
					<div className="-user" key={ e }>
						<div className="-text">{ e }</div>
						<i
							className="icon-close-round"
							aria-hidden="true"
							data-email={ e }
						/>
					</div>
				)
			})
		}

		return (
			<div className={ className }>
				<div className="-button">
					<button className={ showButtonClass } onClick={ this.handleShow }>{ showButtonText }</button>
				</div>

				<div className="-add">
					<div className="form-item">
						<label htmlFor="create_topic_title">Title</label>

						<input type="text"
							id="create_topic_title"
							value={ title }
							onChange={ this.handleTitleChange }
						/>
					</div>

					<div className="form-item">
						<label htmlFor="create_topic_content">Description</label>

						<textarea
							id="create_topic_content"
							rows="10"
							value={ content }
							onChange={ this.handleContentChange }
						/>
					</div>

					<div className="form-item">
						<label htmlFor="create_topic_privacy">Privacy</label>

						<div className="form-select">
							<select id="create_topic_privacy" value={ privacy } onChange={ this.handlePrivacyChange }>
								<option value="">Forum Default</option>
								<option value="user_emails">Specific Users</option>
							</select>

							<i
								className="icon-chevron-down"
								aria-hidden="true"
								onClick={ this.handleUserRemove }
							/>
						</div>
					</div>

					{ 'user_emails' == privacy &&
						<div className="form-item">
							<div className={ userAddClass }>
								<form onSubmit={ this.handleUserAddSubmit }>
									<div className="form-item">
										<input
											type="email"
											value={ userAddInput }
											placeholder="Enter an email address"
											onChange={ this.handleUserAddChange }
										/>

										<button className="button">Add</button>
									</div>

									{ usersMarkup &&
										<div className="form-item">
											{ usersMarkup }

											<p>
												These users will receive an invitation to join via email.
											</p>
										</div>
									}
								</form>
							</div>
						</div>
					}

					<div className="form-item">
						<button className="button" onClick={ this.handleCreateTopic } disabled={ buttonDisabled } >Create topic</button>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.forum.isLoading,
		topic: state.forum.selectedTopic
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		createTopic: ( title, content, privacy, users ) => {
			dispatch( createTopic( title, content, privacy, users ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( CreateTopic )



// WEBPACK FOOTER //
// ./views/main/forum/CreateTopic.jsx